import { useCallback, useEffect, useRef, useState } from "react"

/**
 * Custom hook to manage DockwaPlus form state with debounced query parameters
 * @returns {Object} Form state and operations
 */
const useDockwaPlusForm = () => {
  const [address, setAddress] = useState(null)
  const [addressComplete, setAddressComplete] = useState(false)
  const [couponCode, setCouponCode] = useState("")
  const [queryParams, setQueryParams] = useState({
    address: null,
    couponCode: "",
  })

  const timeoutRef = useRef(null)

  const updateField = useCallback((field, value) => {
    if (field === "couponCode") {
      setCouponCode(value)
    }
  }, [])

  const resetForm = useCallback(() => {
    setAddress(null)
    setAddressComplete(false)
    setCouponCode("")
    setQueryParams({ address: null, couponCode: "" })
  }, [])

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setQueryParams({ address, couponCode })
    }, 300)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [address, couponCode])

  return {
    address,
    setAddress,
    addressComplete,
    setAddressComplete,
    couponCode,
    queryParams,
    updateField,
    resetForm,
  }
}

export default useDockwaPlusForm
